import { atom } from 'jotai'

/**
 * Gini Tanıtım videosu (banner popup) ile ChatWidget arasındaki ortak durum.
 * - `playing`: tanıtım popup'ı açık; ChatWidget tanıtım/anket baloncuğunu ve otomatik açılışı bekletir.
 * - `flying`: popup kapandı; ChatWidget logoyu ekran ortasından FAB'in güncel konumuna uçurur,
 *   varışta durumu `idle`'a çeker.
 */
export type GiniIntroFlightState = 'idle' | 'playing' | 'flying'

export const giniIntroFlightAtom = atom<GiniIntroFlightState>('idle')
